import { Alert, List } from '@mantine/core';

/**
 * Avisos que a API devolve em `meta.avisos` (ex.: série sem dado no período, fonte
 * externa fora do ar). No legado eram `st.warning`. Recebe os avisos de uma ou mais
 * consultas da página; repetidos aparecem uma vez.
 */
export function AvisosApi({ avisos }: { avisos: (string[] | undefined)[] }) {
  const unicos = [...new Set(avisos.flatMap((a) => a ?? []))];
  if (unicos.length === 0) return null;
  return (
    <Alert color="yellow" title={unicos.length > 1 ? 'Avisos' : undefined}>
      {unicos.length === 1 ? (
        unicos[0]
      ) : (
        <List size="sm">
          {unicos.map((a) => (
            <List.Item key={a}>{a}</List.Item>
          ))}
        </List>
      )}
    </Alert>
  );
}
